/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Web_DescInputs */

const en_pc_dl_file_web_desc = /** @type {(inputs: Pc_Dl_File_Web_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The WebAssembly app, to host yourself.`)
};

const zh_pc_dl_file_web_desc = /** @type {(inputs: Pc_Dl_File_Web_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebAssembly 版本，可自行部署。`)
};

/**
* | output |
* | --- |
* | "The WebAssembly app, to host yourself." |
*
* @param {Pc_Dl_File_Web_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_web_desc = /** @type {((inputs?: Pc_Dl_File_Web_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Web_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_web_desc(inputs)
	return zh_pc_dl_file_web_desc(inputs)
});
export { pc_dl_file_web_desc as "pc.dl.file.web.desc" }